<!--
 * @Author: 陈大仙人
 * @Date: 2024-01-10 17:47:03
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2024-01-11 12:04:58
 * @FilePath: /akx-pc-main/src/login/components/ad-tip.vue
-->
<template>
  <div class="pos-tip" @click="handleBg" v-if="visable">
    <div class="pos-tip-content" @click.stop="stop" :style="{ backgroundImage: 'url(' + info.tipImg + ')'}" @click="handle">
      <p class="pos-tip-content-p" v-if="info.phone">{{info.phone}}</p>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
export default {
  name: 'tip',
  props: {
    visable: Boolean,
    info: Object,
  },
  methods: {
    handleBg() {
      this.$emit('update:visable', false);
    },
    handle() {
      const phone = this.info.phone;
      if (!phone) return;
      let oInput = document.createElement('input');
      oInput.value = phone;
      oInput.display = 'none';
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand('Copy'); // 执行浏览器复制命令
      Message.success({
        message: '已复制,请至微信中添加,粘贴微信号添加客服',
      });
      oInput.remove();
    },
    stop() {},
  },
};
</script>

<style scoped>
.pos-tip {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
}

.pos-tip-content {
  width: 480px;
  height: 345px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}

.pos-tip-content-p {
  color: #50e2c2;
  font-size: 25px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  line-height: 1;
  text-align: center;
}
</style>
